import executeMobileCarousels from '../mobilecarousel/index';
import eikaAccordion from './accordion';
import AdvisorListWithSorting from './advisorlist';
import advisorlistMore from './advisorlist-more';
import closeDynamicCard from './closables';
import comparisonTable from './comparisontable';
import EikaMenuComponent from './header';
import eikaImageZoom from './imagezoom';
import loginDropdown from './logindropdown';
import scriptLoaderEnhanced from './scriptLoaderEnhanced';
import { detectScrollbarWidth } from './scrollbar';
import EikaElasticSearch from './search';
import eikaSidemenu from './sidemenu';
import skipToContent from './skip-to-content';
import EikaTooltips from './tooltip';
import loadYoutubeEmbed from './youtubeloader';

import './styles/index.scss';

detectScrollbarWidth();
EikaMenuComponent(document.querySelector('header.header23')!);
closeDynamicCard();
eikaAccordion();
eikaImageZoom();
eikaSidemenu(document.querySelector('.sidemenu')!);
scriptLoaderEnhanced(window.document);
loginDropdown(document.querySelector('#loginbuttondropdown'));
EikaTooltips();
comparisonTable();
AdvisorListWithSorting('advisorlist-sortable');
loadYoutubeEmbed('.sgw-video-card__media-iframe');
advisorlistMore();
skipToContent();
EikaElasticSearch('.eika-elastic-search');
executeMobileCarousels();
